import { Select, Segmented, Drawer, Empty } from 'antd'
import Map from './Map'
import InfoPanel from './InfoPanel'
import UnitStrip from './UnitStrip'
import './styles/dashboard_desktop.scss'

// Option C: top toolbar (searchable unit selector + status filter + count),
// full-width map, and a right-side detail drawer. Pure presentation — all state
// lives in index.jsx. Replaces the old fixed 3-column grid that squished on resize.
export const DashboardDesktop = ({
  vehicles, selectedUnitID, mapCoord, dispatch,
  handleMarkerClick, onSelectUnit, onCloseDetail, filter, setFilter,
}) => {
  const list = vehicles || []
  const selected = list.filter(i => i.unit_id.startsWith(selectedUnitID))[0]

  const options = list.map(v => ({
    value: v.unit_id,
    label: v.serial_number || v.unit_id,
  }))

  return (
    <div className="rz-dashboard-desktop">
      <div className="rz-dd-toolbar">
        <Select
          className="rz-dd-search"
          showSearch
          allowClear
          placeholder="Search units…"
          optionFilterProp="label"
          value={selectedUnitID || undefined}
          options={options}
          onChange={(unitId) => {
            if (!unitId) { onCloseDetail(); return }
            const v = list.find(x => x.unit_id === unitId)
            if (v) onSelectUnit(v)
          }}
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        />
        <Segmented
          options={['All', 'Online', 'Offline']}
          value={filter}
          onChange={setFilter}
        />
        <span className="rz-dd-count">{list.length} unit{list.length === 1 ? '' : 's'}</span>
      </div>

      <UnitStrip className="rz-dd-chips" vehicles={list} selectedUnitID={selectedUnitID} onSelect={onSelectUnit} />

      <div className="rz-dd-map">
        <Map handleClick={handleMarkerClick} selectedUnitID={selectedUnitID} mapCoord={mapCoord} vehicles={list} />

        <Drawer
          className="rz-dd-drawer"
          title={selected ? (selected.serial_number || selected.unit_id) : 'Unit detail'}
          placement="right"
          width={380}
          open={selectedUnitID !== ''}
          onClose={onCloseDetail}
          mask={false}
          getContainer={false}
          rootStyle={{ position: 'absolute' }}
        >
          {selected
            ? <InfoPanel dispatch={dispatch} item={selected} />
            : <Empty className="rz-dd-empty" description="Choose a unit to display data" />}
        </Drawer>
      </div>
    </div>
  )
}

export default DashboardDesktop
